'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _ngRedux = require('ng-redux');

var _ngRedux2 = _interopRequireDefault(_ngRedux);

var _immutable = require('immutable');

var _scoresMdl = require('./scores.mdl.scss');

var _scoresMdl2 = _interopRequireDefault(_scoresMdl);

var _routerHistory = require('../../../../../router-history');

var _routerHistory2 = _interopRequireDefault(_routerHistory);

var _events = require('ifeis-isomorphic/lib/redux/actions/events');

var _paths = require('ifeis-isomorphic/lib/redux/actions/events/paths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ScoresController = function () {
  function ScoresController($state, $scope, $ngRedux, fRouterHistoryService, msgService, feis) {
    _classCallCheck(this, ScoresController);

    this._ = {
      $state: $state,
      fRouterHistoryService: fRouterHistoryService,
      msgService: msgService
    };

    this.feis = feis;

    // For the non-chart view, default filters and sorts.
    this.orderBy = 'name';
    this.orderReverse = false;
    this.filter = '';

    $ngRedux.connect(function (state) {
      return {
        loading: (0, _paths.eventsAreLoading)(state, feis.id),
        events: (0, _paths.getEvents)(state, feis.id)
      };
    })(this);
    $ngRedux.dispatch((0, _events.getEvents)(feis.id));
  }

  _createClass(ScoresController, [{
    key: 'back',
    value: function back() {
      this._.fRouterHistoryService.back();
    }
  }, {
    key: 'order',
    value: function order(by) {
      if (by !== this.orderBy) {
        this.orderBy = by;
        this.orderReverse = false;
      } else {
        this.orderReverse = !this.orderReverse;
      }
    }
  }, {
    key: 'open',
    value: function open(event) {
      this._.$state.go('feiseanna.one.review', { source: 'scores', event: event.get('id') });
    }
  }]);

  return ScoresController;
}();

exports.default = _angular2.default.module('ifeis.routes.feiseanna.one.admin.scores', ['ifeis.syllabi.store', 'ifeis.syllabi.actions', 'ifeis.syllabi.editor']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.scores', {
    url: '/scores',
    template: require('./scores.mdl.html'),
    controller: ScoresController,
    controllerAs: 'scores',
    ncyBreadcrumb: {
      label: 'Scores',
      parent: 'feiseanna.one.admin.manager'
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/scores/scores.mdl.js
// module id = 570
// module chunks = 0